import React from 'react';
import ParticlesScene from 'game/scenes/test/ParticlesScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function ParticlesScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [ParticlesScene],
            physics: {
              arcade: {
                gravity: { y: 0 },
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
